import React, { useEffect, useRef, useState } from 'react';

import teamSwim from '../assets/team-swim.jpg';
import teamTraining from '../assets/team-training.jpg';
import teamRunning from '../assets/team-running.jpg';
import teamCycling from '../assets/team-cycling.jpg';

const images = [
  { src: teamSwim, alt: 'NataciÃ³n en aguas abiertas', label: 'Swim' },
  { src: teamTraining, alt: 'Entrenamiento funcional', label: 'Train' },
  { src: teamRunning, alt: 'Running en grupo', label: 'Run' },
  { src: teamCycling, alt: 'Ciclismo de carretera', label: 'Bike' },
];

const TeamGallery = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{
        background: 'var(--bg-primary)',
        padding: '4rem 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div className="container">
        {/* Subtle top accent line */}
        <div style={{
          height: '1px',
          background: 'linear-gradient(to right, transparent 5%, rgba(237, 0, 140, 0.3) 30%, rgba(237, 0, 140, 0.3) 70%, transparent 95%)',
          marginBottom: '8px'
        }} />

        {/* Gallery Grid */}
        <div
          className="team-gallery-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '6px',
            height: '340px',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
          }}
        >
          {images.map((img, index) => (
            <div
              key={index}
              className="team-gallery-item"
              style={{
                position: 'relative',
                overflow: 'hidden',
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? 'scale(1)' : 'scale(1.05)',
                transition: `opacity 0.8s ease-out ${index * 0.15}s, transform 0.8s ease-out ${index * 0.15}s`,
              }}
            >
              {/* Image */}
              <img
                src={img.src}
                alt={img.alt}
                className="team-gallery-img"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center 30%',
                  transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), filter 0.6s ease',
                  filter: 'brightness(0.35) saturate(0.4)',
                }}
              />

              {/* Magenta duotone overlay */}
              <div
                className="team-gallery-overlay"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(145deg, rgba(237, 0, 140, 0.12) 0%, rgba(10, 10, 10, 0.6) 60%, rgba(10, 10, 10, 0.85) 100%)',
                  transition: 'opacity 0.6s ease',
                  pointerEvents: 'none',
                }}
              />

              {/* Bottom gradient for label readability */}
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '50%',
                background: 'linear-gradient(to top, rgba(10, 10, 10, 0.8) 0%, transparent 100%)',
                pointerEvents: 'none',
                transition: 'opacity 0.6s ease',
              }} />

              {/* Discipline label */}
              <div
                className="team-gallery-label"
                style={{
                  position: 'absolute',
                  bottom: '1.25rem',
                  left: '1.25rem',
                  color: 'rgba(255, 255, 255, 0.5)',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  letterSpacing: '0.2em',
                  textTransform: 'uppercase',
                  fontFamily: "'Montserrat', 'Inter', sans-serif",
                  transition: 'color 0.4s ease, transform 0.4s ease',
                  transform: 'translateY(0)',
                }}
              >
                {img.label}
              </div>

              {/* Thin accent border on hover - bottom */}
              <div
                className="team-gallery-accent"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: 'var(--accent-primary)',
                  transform: 'scaleX(0)',
                  transformOrigin: 'left',
                  transition: 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  pointerEvents: 'none',
                }}
              />
            </div>
          ))}
        </div>

        {/* Subtle bottom accent line */}
        <div style={{
          height: '1px',
          background: 'linear-gradient(to right, transparent 5%, rgba(237, 0, 140, 0.3) 30%, rgba(237, 0, 140, 0.3) 70%, transparent 95%)',
          marginTop: '8px'
        }} />
      </div>

      <style>{`
        .team-gallery-item:hover .team-gallery-img {
          transform: scale(1.08);
          filter: brightness(0.55) saturate(0.7) !important;
        }

        .team-gallery-item:hover .team-gallery-overlay {
          opacity: 0.4 !important;
        }

        .team-gallery-item:hover .team-gallery-label {
          color: var(--accent-primary) !important;
          transform: translateY(-4px) !important;
        }

        .team-gallery-item:hover .team-gallery-accent {
          transform: scaleX(1) !important;
        }

        @media (max-width: 768px) {
          .team-gallery-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            height: auto !important;
          }
          .team-gallery-item {
            height: 220px;
          }
        }

        @media (max-width: 480px) {
          .team-gallery-grid {
            grid-template-columns: 1fr !important;
            gap: 2px !important;
          }
          .team-gallery-item {
            height: 200px;
          }
        }
      `}</style>
    </section>
  );
};

export default TeamGallery;

